
export type GetRoadmapsListType = typeof GetRoadmapsListType[keyof typeof GetRoadmapsListType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetRoadmapsListType = {
  popular: 'popular',
  created_by_user: 'created_by_user',
  subscribed_by_user: 'subscribed_by_user',
} as const;
